/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import { ApolloProvider } from '@apollo/client'
import createClient from './create-client'

export default ({ element }, options) => (
  <ApolloProvider client={createClient(options.endpointUrl)}>{element}</ApolloProvider>
)
